// Copyright (c) Ensho Health, 2021 to present

import api from '../api';
import { setNotification, NOTIFICATION_TYPES } from './notification.action.js';

const PREFIX = 'pii';
export const ACTION_TYPES = {
  PII_COLLECTED: `${PREFIX}-PII_COLLECTED`,
  ADD_PATIENTS: `${PREFIX}-ADD_PATIENTS`,
  ERROR: `${PREFIX}-ERROR`
};

export function fetchPii() {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const unfetchedPii = Object.values(state.pii.pii).filter(
        (pii) => !pii.piiFetched
      );
      const completedPii = await Promise.all(
        unfetchedPii.map(async (pii) => {
          const piiInClear = await api.encryption.fetchPii(pii.patientId);
          pii.name = piiInClear.name;
          pii.dob = piiInClear.dob;
          pii.hcn = piiInClear.hcn;
          pii.postal = piiInClear.postal;
          pii.piiFetched = true;
          return pii;
        })
      );
      dispatch({ type: ACTION_TYPES.PII_COLLECTED, payload: completedPii });
    } catch (error) {
      console.error(error.message);
      const state = getState();
      dispatch(
        setNotification({
          type: NOTIFICATION_TYPES.ERROR,
          serverMessage: error.message,
          info: {
            location: 'pii.action.fetchPii',
            userHasCodAccess: state?.user.data.hasCodAccess
          },
          display: 'Error while fetching pii services'
        })
      );
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}
